import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { getExerciseDetails } from "../../../api/endpoints/ExerciseEndpoints";

export default function useGetExerciseDetails(exerciseId: string) {
  const getExerciseDetailsFn = useCallback(() => {
    return getExerciseDetails(exerciseId);
  }, [exerciseId]);

  return useQuery({
    queryKey: ["exercise", exerciseId],
    queryFn: getExerciseDetailsFn,
  });
}
